
export class MailingRecord {
    id: number;
    patientId: string;
    clxPatientId: string;
    firstName: string;
    lastName: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zipCode: string;
    gender: string;
    dateOfBirth: string;
    age: number;
    lastExamDate: string;
    months: number;
    monthsOriginal: number;
    isActive: boolean;
    brandId: number;
    mailingId: number;
    mailingFileId: number;
    campaignTypeId: number;
    campaignTypeName: string;
    storeLocationId: number; 
    storeNumber: string;
    phone: string;
    email: string;
    custom1: string;
    custom2: string;
    custom3: string;
    custom4: string;
    custom5: string;
}
